import { pick } from 'lodash'
import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  total: 0,
  items: [],
  full: {}
}

const actions = generateActions('actions/list/GET_TOTAL')
const listActions = generateActions('actions/list/GET_LIST')
const getFullActions = generateActions('actions/list/GET_FULL_INFO')

export const getCount = createAction(API_CONST, () => ({
  actions,
  url: 'actions/count'
}))

export const getAction = createAction(API_CONST, actionId => 
  {//console.log('actionId',actionId);
    return ({
  actions: getFullActions,
  url: `actions/${actionId}`
})})

export const getActions = createAction(
  API_CONST,
  (offset = 0, params = {}) => {
    //console.log('get actions params', params);
    return ({
    params: { limit: 10, ...params, offset },
    actions: listActions,
    url: 'actions'
  })},
  (offset = 0) => ({ rewrite: !offset })
)

export const clearList = createAction('actions/list/CLEAR')

//
const reformat = (items = []) => items.map(item => {
  return {
    ...pick(item, [ '_id', 'alias', 'title', 'startDate', 'closeDate', 'externalPaymentsStats', 'image', 'externalpartnersId']),
  }
})

export default handleActions({
  [actions[1]]: (state, { payload }) => ({
    ...state,
    total: payload.value || 0
  }),
  [clearList]: state => ({ ...initial }),
  [listActions[0]]: (state, { meta }) => {
    //console.log('listActions[0] - state', state)
    return ({
    ...state,
    items: meta.rewrite ? [] : state.items
  })},
  [listActions[1]]: (state, { payload = [] }) => {
    //console.log('listActions[1] - payload', payload)
    return ({
    ...state,
    items: [ ...state.items, ...reformat(payload) ]
  })},
  [getFullActions[1]]: (state, { payload }) => {
    //при наличие alias будет включен в ссылку на лот, если нет остается id
	let alias = payload._id
	if(!payload.withId)
    {
      alias = payload.alias
    }
    return ({
      ...state,
      full: {
        ...state.full,
        ...((payload && payload._id) ? { [alias]: payload } : {})
      }
    })
  }
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/actions/list.js